// import AppConstants from "../../../../../config/app.constants";

import TNTControlBase from "../../util/TNTControlBase";

class ConfigurationController extends TNTControlBase{
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state;
    this.acl = {};
    this.hasACL = {};
    this.id = 'configuration'
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }	
}

export default ConfigurationController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/configuration/configuration.controller.js